/**
 * AG-Grid specific configuration constants
 */

import {
	DEFAULT_CACHE_BLOCK_SIZE,
	DEFAULT_PAGE_SIZE,
	DEFAULT_PAGE_SIZE_SELECTOR,
} from "../ui/pagination";

// Re-export pagination constants for grid context
export { DEFAULT_CACHE_BLOCK_SIZE, DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_SELECTOR };

// AG-Grid specific settings
export const GRID_THEME = "ag-theme-alpine";
export const COLUMN_MIN_WIDTH = 100;
export const COLUMN_MAX_WIDTH = 500;
export const ROW_HEIGHT = 40;
export const HEADER_HEIGHT = 50;

// Grid row selection
export const ROW_SELECTION_SINGLE = "single";
export const ROW_SELECTION_MULTIPLE = "multiple";

// Grid loading overlay
export const LOADING_OVERLAY_COMPONENT = "customLoadingOverlay";
export const NO_ROWS_OVERLAY_COMPONENT = "customNoRowsOverlay";

// Filter options to exclude blank/notBlank
export const TEXT_FILTER_OPTIONS = [
	"contains",
	"notContains",
	"equals",
	"notEqual",
	"startsWith",
	"endsWith",
];
export const NUMBER_FILTER_OPTIONS = [
	"equals",
	"notEqual",
	"lessThan",
	"lessThanOrEqual",
	"greaterThan",
	"greaterThanOrEqual",
	"inRange",
];
